import { BonusSettlementSupplierStatus } from '@synergy/models';
import { createSelector } from 'reselect';

import { AppState } from '../../../../store/models/app-state';

export const bonusSettlementsState = (state: AppState) => state.bonusSettlements;

export const bonusSettlementDetailSelector = createSelector(bonusSettlementsState, state => {
    if (!state.detail.bonusSettlementDetail) {
        return null;
    }

    const { bonusSettlementDetail } = state.detail;

    return {
        ...bonusSettlementDetail,
        bonusConditions: bonusSettlementDetail?.bonusConditions.map(condition => ({
            ...condition,
            bonusCondition: {
                ...condition.bonusCondition,
                percentage: condition.bonusCondition.percentage ? condition.bonusCondition.percentage / 100 : undefined,
            },
        })),
        customerBonusSettlements: bonusSettlementDetail?.customerBonusSettlements.map(settlement => ({
            ...settlement,
            customerBonusPayout:
                settlement.customerBonusPayout === undefined || settlement.customerBonusPayout === null
                    ? undefined
                    : settlement.customerBonusPayout / 100,
            payout: settlement.payout / 100,
            customerBonusBase: settlement.customerBonusBase / 100,
            bonusConditionValues: settlement.bonusConditionValues.map(condition => ({
                ...condition,
                value: condition.value === 0 ? null : condition.value,
            })),
        })),
    };
});

export const bonusSettlementDetailLoadingSelector = createSelector(
    bonusSettlementsState,
    state => state.detail.loading
);

export const bonusSettlementDetailSubmittedSelector = createSelector(
    bonusSettlementsState,
    state => state.detail.submitted
);

export const bonusSettlementDetailReadOnlySelector = createSelector(bonusSettlementsState, state => {
    const { bonusSettlementDetail } = state.detail;

    return (
        bonusSettlementDetail?.status === BonusSettlementSupplierStatus.Completed ||
        bonusSettlementDetail?.status === BonusSettlementSupplierStatus.AutomaticallySent ||
        bonusSettlementDetail?.status === BonusSettlementSupplierStatus.Sent
    );
});
